import useCheckoutComplete from "@/lib/queries/payment/useCheckoutComplete";
import useCheckoutSession from "@/lib/queries/payment/useCheckoutSession";
import useUnauthenticatedCheckoutComplete from "@/lib/queries/payment/useUnauthenticatedCheckoutComplete";
import useUnauthenticatedCheckoutSession from "@/lib/queries/payment/useUnauthenticatedCheckoutSession";
import { useStytchSession } from "@stytch/react";
import { useEffect } from "react";
import Confetti from "react-confetti";
import { Link } from "react-router-dom";
import { ROOT, AUTHENTICATE } from "@/lib/links";

function CheckoutReturn() {
  const sessionId = new URLSearchParams(window.location.search).get(
    "session_id"
  );

  const { session } = useStytchSession();
  const isAuthenticated = session !== null;

  // Use different hooks based on authentication status
  const authenticatedSession = useCheckoutSession({
    sessionId: sessionId ?? "",
    enabled: !!sessionId && isAuthenticated,
  });

  const unauthenticatedSession = useUnauthenticatedCheckoutSession({
    sessionId: sessionId ?? "",
    enabled: !!sessionId && !isAuthenticated,
  });

  const {
    data: _data,
    error,
    isSuccess,
    isError,
  } = isAuthenticated ? authenticatedSession : unauthenticatedSession;

  const authenticatedComplete = useCheckoutComplete({
    sessionId: sessionId ?? "",
  });
  const unauthenticatedComplete = useUnauthenticatedCheckoutComplete({
    sessionId: sessionId ?? "",
  });

  const { mutate } = isAuthenticated
    ? authenticatedComplete
    : unauthenticatedComplete;

  useEffect(() => {
    if (sessionId && isSuccess) {
      mutate();
    }
  }, [sessionId, isSuccess, mutate]);

  useEffect(() => {
    if (isError) {
      console.error("Checkout error:", error);
      throw error;
    }
  }, [error, isError, sessionId]);

  return (
    <div className="flex flex-col items-center justify-center w-full min-h-full gap-4">
      {isSuccess && (
        <>
          <h1 className="text-6xl font-bold text-primary animate-bounce">
            🥳 Fantastic! 🥳
          </h1>
          <p className="max-w-screen-sm text-2xl text-center">
            {isAuthenticated ? (
              <>
                You're now a fully-fledged subscriber to Teacher Tools! Head on
                over to the{" "}
                <Link
                  className="text-2xl font-semibold underline text-primary"
                  to={ROOT}
                >
                  dashboard
                </Link>{" "}
                to get started! 🚀
              </>
            ) : (
              <>
                Your subscription is complete! An account has been created for
                you. Please check your email for login instructions, then head
                to the{" "}
                <Link
                  className="text-2xl font-semibold underline text-primary"
                  to={AUTHENTICATE}
                >
                  login page
                </Link>{" "}
                to access your account! 🚀
              </>
            )}
          </p>
          <Confetti recycle={false} />
        </>
      )}
    </div>
  );
}

export default CheckoutReturn;
